// Contact form confirmation
var wpcf7Elm = document.querySelector( '.wpcf7' );
if (wpcf7Elm) {
    wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
        const confirmation = document.getElementById('confirmation-form').outerHTML.replace('hidden-form', 'display-form');
        document.querySelector('#form-wpcf7').outerHTML = confirmation;
        document.querySelector('.wpcf7-response-output').style.display = 'none';
    }, false );
}